import { FormAttemptStatusEnum } from '@elearning-platform/api-types/enums';
import { Color } from '@elearning-platform/ui';
import { useCallback } from 'react';
import { TransProps, useTranslation } from 'react-i18next';

import { LabelStatusDetails, UseLegalFormsStatic } from '../interfaces';

export const useLegalFormsStatic: () => UseLegalFormsStatic = (): UseLegalFormsStatic => {
  const { t }: TransProps<never> = useTranslation();

  const getLabelStatusDetails: (status: FormAttemptStatusEnum) => LabelStatusDetails = useCallback(
    (status: FormAttemptStatusEnum): LabelStatusDetails => {
      switch (status) {
        case FormAttemptStatusEnum.Created:
          return {
            content: t('competence.app.useLegalFormsStatic.formAttemptStatus.created'),
            colorsData: { textColor: Color.Gray800, backgroundColor: Color.White, borderColor: Color.Gray300 },
          };
        case FormAttemptStatusEnum.InProgress:
          return {
            content: t('competence.app.useLegalFormsStatic.formAttemptStatus.inProgress'),
            colorsData: { textColor: Color.Blue500, backgroundColor: Color.Blue100 },
          };
        case FormAttemptStatusEnum.WaitingForReview:
          return {
            content: t('competence.app.useLegalFormsStatic.formAttemptStatus.waitingForReview'),
            colorsData: { textColor: Color.Yellow900, backgroundColor: Color.Yellow100 },
          };
        case FormAttemptStatusEnum.InReview:
          return {
            content: t('competence.app.useLegalFormsStatic.formAttemptStatus.inReview'),
            colorsData: { textColor: Color.Yellow900, backgroundColor: Color.Yellow100 },
          };
        case FormAttemptStatusEnum.Rejected:
          return {
            content: t('competence.app.useLegalFormsStatic.formAttemptStatus.rejected'),
            colorsData: { textColor: Color.Red900, backgroundColor: Color.Red100 },
          };
        case FormAttemptStatusEnum.Approved:
          return {
            content: t('competence.app.useLegalFormsStatic.formAttemptStatus.approved'),
            colorsData: { textColor: Color.Green300, backgroundColor: Color.Green100 },
          };
        default:
          status satisfies never;

          return {
            content: status,
            colorsData: { textColor: Color.Gray800, backgroundColor: Color.White, borderColor: Color.Gray300 },
          };
      }
    },
    [t]
  );

  return { getLabelStatusDetails };
};
